import { render, staticRenderFns } from "./DataSpaceManagement.vue?vue&type=template&id=4e5f2684&"
import script from "./DataSpaceManagement.vue?vue&type=script&lang=ts&"
export * from "./DataSpaceManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports